import type { HelpFile } from '../../types/help'
import { ProvisioningTestIds } from '../../../testids/ProvisioningTestIds'

export const provisioningHelp: HelpFile = {
  docPage: '/docs/provisioning/overview',
  texts: {
    [ProvisioningTestIds.provisioningWelcomeCard]:
      'Startseite des Provisionierungs-Bereichs — wählen Sie ein Werkzeug aus der Seitenleiste: Dashboard, Aufgaben-Queue und Aufgabenhistorie.',
  },
}
